// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"5c42bcb7","144":"de3bcb01","154":"a239a311","198":"076f503e","307":"f44c08c9","563":"1d6208f1","693":"0b38aef0","703":"e3650695","756":"14863726","816":"3c0abe51","986":"ac49a9ae"}[chunkId] + ".chunk.js";
};